import {Component, EventEmitter, inject, Output} from '@angular/core';
import {map} from 'rxjs/operators';
import {usingLoading} from 'shared/utils/rxjs';
import {ConceptsService} from '@modules/activities/core/services/concepts.service';
import {ConceptEntity} from 'shared/models';
import {Filter} from '@modules/activities/core/activities-search-engine/filter-selector/filter';

@Component({
    selector: 'app-concept-filter-selector',
    templateUrl: './concept-filter-selector.component.html',
    styleUrls: ['./concept-filter-selector.component.scss'],
    standalone: false
})
export class ConceptFilterSelectorComponent {
    @Output() conceptSelected = new EventEmitter<ConceptEntity>();

    public isLoading = true;

    private conceptsService = inject(ConceptsService);

    public availableConceptsToFilters$ = this.conceptsService.getConcepts().pipe(
        map((concepts) => concepts.entities),
        map((concepts) => concepts.map(e => this.conceptToFilter(e))),
        usingLoading((isLoading) => this.isLoading = isLoading)
    );

    private conceptToFilter = (concept: ConceptEntity): Filter<ConceptEntity> => ({
        label: concept.get('name'),
        id: concept.id,
        icon: 'add',
        type: 'concept',
        originalResource: concept
    });

    public onConceptFilterSelected($event: Filter<ConceptEntity>): void {
        this.conceptSelected.emit($event.originalResource);
    }
}
